import React from "react";

export const STATUS_LIST = [
  "CREATED", "DESIGN_IN_PROGRESS", "DESIGN_APPROVED",
  "IN_PRODUCTION", "QUALITY_PENDING", "QUALITY_PASSED",
  "QUALITY_FAILED", "REWORK", "REJECTED_SCRAPPED",
  "READY_FOR_DISPATCH", "DISPATCHED", "ON_HOLD", "CANCELLED",
];

export const STATUS_LABELS = {
  CREATED: "Created",
  DESIGN_IN_PROGRESS: "Design In Progress",
  DESIGN_APPROVED: "Design Approved",
  IN_PRODUCTION: "In Production",
  QUALITY_PENDING: "Quality Pending",
  QUALITY_PASSED: "Quality Passed",
  QUALITY_FAILED: "Quality Failed",
  REWORK: "Rework",
  REJECTED_SCRAPPED: "Rejected / Scrapped",
  READY_FOR_DISPATCH: "Ready For Dispatch",
  DISPATCHED: "Dispatched",
  ON_HOLD: "On Hold",
  CANCELLED: "Cancelled",
};

const CLASS_MAP = {
  CREATED: "bg-slate-100 text-slate-700 border-slate-200",
  DESIGN_IN_PROGRESS: "bg-blue-50 text-blue-700 border-blue-200",
  DESIGN_APPROVED: "bg-indigo-50 text-indigo-700 border-indigo-200",
  IN_PRODUCTION: "bg-amber-50 text-amber-800 border-amber-200",
  QUALITY_PENDING: "bg-yellow-50 text-yellow-800 border-yellow-200",
  QUALITY_PASSED: "bg-emerald-50 text-emerald-700 border-emerald-200",
  QUALITY_FAILED: "bg-red-50 text-red-700 border-red-200",
  REWORK: "bg-rose-50 text-rose-700 border-rose-200",
  REJECTED_SCRAPPED: "bg-red-100 text-red-800 border-red-300",
  READY_FOR_DISPATCH: "bg-teal-50 text-teal-700 border-teal-200",
  DISPATCHED: "bg-emerald-100 text-emerald-800 border-emerald-300",
  ON_HOLD: "bg-gray-100 text-gray-700 border-gray-300",
  CANCELLED: "bg-slate-200 text-slate-700 border-slate-300",
};

export default function StatusBadge({ status, className = "" }) {
  const cls = CLASS_MAP[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 border px-2 py-0.5 rounded text-[11px] font-semibold tracking-wide uppercase font-mono ${cls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

// Main production journey used by the stepper (excludes ON_HOLD / CANCELLED / REJECTED_SCRAPPED / REWORK branches)
export const JOURNEY = [
  "CREATED",
  "DESIGN_IN_PROGRESS",
  "DESIGN_APPROVED",
  "IN_PRODUCTION",
  "QUALITY_PENDING",
  "QUALITY_PASSED",
  "READY_FOR_DISPATCH",
  "DISPATCHED",
];
